/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import { Autoplay } from 'swiper/modules'
import PropTypes from 'prop-types'
import { Button, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function MarqueePreview({ srcs, setSrcs, redirectUrl }) {
  const [key, setKey] = useState(0)
  const [imageUrls, setImageUrls] = useState([])
  const prevImageUrlsRef = useRef([])
  const [showMarquee, setShowMarquee] = useState(true)

  const validImages = srcs.filter(
    (src) =>
      src.file &&
      (src.file instanceof File ||
        src.file instanceof Blob ||
        typeof src.file === 'string')
  )

  useEffect(() => {
    if (!validImages.length) return

    const newUrls = validImages.map((src) => ({
      ...src,
      url:
        src.file instanceof Blob || src.file instanceof File
          ? URL.createObjectURL(src.file)
          : src.file,
    }))

    if (JSON.stringify(newUrls) !== JSON.stringify(prevImageUrlsRef.current)) {
      setImageUrls(newUrls)
      prevImageUrlsRef.current = newUrls
    }

    const oldUrls = prevImageUrlsRef.current
    setTimeout(() => {
      oldUrls.forEach((url) => {
        if (typeof url === 'string' && url.startsWith('blob:')) {
          // URL.revokeObjectURL(url)
        }
      })
    }, 5000)
  }, [validImages])

  useEffect(() => {
    if (imageUrls.length > 0) {
      setKey((prev) => prev + 1)
    }
  }, [imageUrls])

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {showMarquee && (
        <div className="marquee-container">
          {validImages.length > 0 && (
            <Button className="close-btn" onClick={() => setShowMarquee(false)}>
              ✕
            </Button>
          )}

          <Swiper
            key={key}
            modules={[Autoplay]}
            slidesPerView="auto"
            spaceBetween={0}
            loop
            loopAdditionalSlides={validImages.length * 2}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            speed={7500}
            allowTouchMove
            cssMode={false}
            grabCursor
          >
            {[...imageUrls, ...imageUrls].map((src, idx) => (
              <SwiperSlide
                key={idx}
                style={{ width: '230px' }}
                onClick={() => {
                  if (redirectUrl) window.open(redirectUrl, '_blank')
                }}
              >
                <div className="image-wrapper">
                  <img
                    className="marquee-item"
                    src={src.url}
                    alt={src.label || 'Image'}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <CIIcon />
        </div>
      )}
      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

MarqueePreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
        PropTypes.string,
      ]),
      label: PropTypes.string,
    })
  ).isRequired,
  setSrcs: PropTypes.func.isRequired,
  redirectUrl: PropTypes.string,
}

MarqueePreview.defaultProps = {
  redirectUrl: '',
}

export default MarqueePreview
